export default "__VITE_ASSET__D7dv8sjw__"